import {
    Heading,
    Button,
    View,
    Flex,
} from "@aws-amplify/ui-react";
import { API, Auth } from "aws-amplify";

export function InfluencerCookbook({
    balance,
    updateBalance,
    subscription,
    clientData,
}) {
    async function handleCookbookButtonClick() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const subject = `InfluencerCookbook button clicked by ${clientData?.email || "unknown"}`;
            const body = [
                `InfluencerCookbook button clicked by ${clientData?.email || "unknown"}`,
                `subscriptionPlan: ${clientData?.subscriptionPlan || "N/A"}`,
                `payments: ${clientData?.payments || "N/A"}`,
                `fiatBalance: ${clientData?.fiatBalance || 0}`,
                `subscriptionId: ${clientData?.subscriptionId || "N/A"}`,
            ].join("\n");

            const request = {
                headers: {
                    Authorization: `${user.signInUserSession.idToken.jwtToken}`,
                },
                body: { subject, body },
            };
            await API.post("gcAPI", "/send-email", request);
            //console.log("Admin email sent successfully from InfluencerCookbook");
        } catch (error) {
            //console.error("Error sending email from InfluencerCookbook:", error);
        }
    }

    return (
        <>
            <View align="center">
                <View maxWidth="1000px" align="left">
                    <Heading
                        level={3}
                        fontWeight={"bold"}
                        textAlign="center"
                        color={"#414c5a"}
                        style={{ lineHeight: "1.5" }}
                    >
                        Influencer Cookbook
                        <br />
                        <br />
                    </Heading>

                    <Flex
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        marginBottom="20px"
                    >
                        <br />
                        Guides for Influencers on how to get the most out of the system.
                        <br />
                        <Button
                            variation="primary"
                            size="large"
                            style={{
                                marginBottom: "10px",
                                padding: "20px 40px",
                            }}
                            onClick={handleCookbookButtonClick}
                        >
                            Coming Soon!
                        </Button>
                        <br />
                    </Flex>
                </View>
            </View>
        </>
    );
}
